import { render, staticRenderFns } from "./image-display.vue?vue&type=template&id=08346d7d&scoped=true&"
import script from "./image-display.vue?vue&type=script&lang=ts&"
export * from "./image-display.vue?vue&type=script&lang=ts&"
import style0 from "./image-display.vue?vue&type=style&index=0&id=08346d7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08346d7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
